import React, { Component } from 'react';
import axios from 'axios';
import Thanks from './../../Thanks';
import { Input, Input1, Textarea } from './../../forms/input';
import ReCAPTCHA from 'react-google-recaptcha';
const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6Le-UtseAAAAAGpB4ucUJNIvZslgvZXc77lRT3tG';

class OrderNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      activePlan: [],
      param1: 0,
      param2: 0,
      param3: 0,
      param4: 0,
    };
    this.reRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
  }

  formTotal = () => {
    const self = this;
    switch (self.props.currency) {
      case 'amd':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'AMD':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'usd':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'eur':
        self.setState({
          param1: '€1000-€3000',
          param2: '€3001-€7000',
          param3: '€7001-€10.000',
          param4: '€10.000+',
        });
        break;
      case 'gbp':
        self.setState({
          param1: '£1000-£3000',
          param2: '£3001-£7000',
          param3: '£7001-£10.000',
          param4: '£10.000+',
        });
        break;
      case 'rub':
        self.setState({
          param1: '₽1000-₽3000',
          param2: '₽3001-₽7000',
          param3: '₽7001-₽10.000',
          param4: '₽10.000+',
        });
        break;
      case 'aud':
        self.setState({
          param1: 'AU $1000 - AU $3000',
          param2: 'AU $3001 - AU $7000',
          param3: 'AU $7001 - AU $10.000',
          param4: 'AU $10.000+',
        });
        break;
      case 'AUD':
        self.setState({
          param1: 'AU $1000 - AU $3000',
          param2: 'AU $3001 - AU $7000',
          param3: 'AU $7001 - AU $.000',
          param4: 'AU $10.000+',
        });
        break;
      case 'sgd':
        self.setState({
          param1: 'SG $1000 - SG $3000',
          param2: 'SG $3001 - SG $7000',
          param3: 'SG $7001 - SG $.000',
          param4: 'SG $10.000+',
        });
        break;
      case 'cad':
        self.setState({
          param1: 'CA $1000 - CA $3000',
          param2: 'CA $3001 - CA $7000',
          param3: 'CA $7001 - CA $.000',
          param4: 'CA $10.000+',
        });
        break;
      case 'nzd':
        self.setState({
          param1: 'NZ $1000 - NZ $3000',
          param2: 'NZ $3001 - NZ $7000',
          param3: 'NZ $7001 - NZ $.000',
          param4: 'NZ $10.000+',
        });
        break;
      default:
        break;
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // console.log(this.props)
    this.formTotal();
  }

  handleChange(param, value) {
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();

    const token = this.reRef.current.getValue();

    if (token) {
      const { activePlan } = this.state;
      let that = this;
      let form_data = new FormData(e.target);
      for (let key in this.state.formdata) {
        form_data.append(key, this.state.formdata[key]);
      }
      form_data.append('country', this.props.country);
      form_data.append('service', this.props.service);
      let budgetPlans = '';

      const planObj = {
        1: 'Generating More Leads',
        2: 'Optimizing Conversion Rate',
        3: 'Increasing website traffic',
        4: 'Increasing brand awareness and visibility',
        5: 'Reducing the cost of customer acquisition',
        6: 'Launching into new markets',
      };

      if (activePlan.length > 0) {
        let final = [];
        this.state.activePlan.forEach((el, item) => {
          final.push(planObj[el]);
        });
        budgetPlans = final.join(',');
      }
      form_data.append('plan', budgetPlans);
      form_data.append('budget', this.props.budget);

      document.body.style.overflow = 'hidden';
      console.log('form_data', Array.from(form_data));
      axios.post('https://mailer.weprodigi.com/api/v1/order-now', form_data).then(response => {
        window.location.href = 'https://weprodigi.com/thank-you';
      });
    }
    this.reRef.current.reset();
  }
  hide = () => {
    document.querySelectorAll('[name=email]').forEach(function (el) {
      el.value = '';
    });
    document.querySelectorAll('[name=company-name]').forEach(function (el) {
      el.value = '';
    });
    document.querySelectorAll('[name=phone-number]').forEach(function (el) {
      el.value = '';
    });
    document.querySelectorAll('[name=website]').forEach(function (el) {
      el.value = '';
    });
    document.querySelectorAll('[name=name]').forEach(function (el) {
      el.value = '';
    });
    document.querySelectorAll('[name=nda]').forEach(function (el) {
      el.checked = false;
    });
    document.querySelectorAll('[name=description]').forEach(function (el) {
      el.value = '';
    });

    this.setState({ activePlan: [] });
    this.props.hide();
  };
  setActivePlans = el => {
    if (!this.state.activePlan.includes(el)) {
      this.state.activePlan.push(el);
    } else {
      this.state.activePlan.splice(this.state.activePlan.indexOf(el), 1);
    }
  };
  render() {
    const { activePlan } = this.state;
    return (
      <>
        <style>{`
                    .radio-item label:before{
                        width:15px;height:15px
                    }
                    .radio-item input[type=radio]:checked+label:after{
                        width: 9px;
                        height: 9px;
                        position: absolute;
                        top: 7px;
                    }
                `}</style>
        <div
          className={
            'fixed z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
            ' ' +
            (this.props.show && !this.state.showThanks ? 'flex' : 'hidden')
          }
        >
          <div className="absolute left-0 top-0 w-full h-full" onClick={this.hide} />
          <div className="relative transform w-11/12 max-w-screen-md max-h-screen-md bg-gray border border-gray-transparent rounded-5 md:scale-100">
            <div
              onClick={this.hide}
              className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
            >
              <span className="font-bold">X</span>
            </div>
            <div className="py-23 px-50 max-h-650  md:max-h-700 overflow-y-auto">
              <p className="text-purple uppercase text-24 text-center font-black leading-none">Proposal Request</p>
              <p className="text-black   text-16 text-center font-black mt-5 mb-15 leading-none uppercase">Paid Ads Services</p>
              <form id="offer-form" method="POST" onSubmit={e => this.onSubmit(e)}>
                <div className="mt-20">
                  <div className="mb-10">
                    <div className="grid grid-cols-2 gap-10">
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Company Name*</p>
                        <div className="mb-10">
                          <Input type="text" name="company-name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                        </div>
                      </div>
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Company Website*</p>
                        <div className="mb-10">
                          {this.props.website && (
                            <Input1
                              type="text"
                              name="website"
                              value={this.props.website}
                              bg="bg-gray-light"
                              required={true}
                              onChange={this.handleChange}
                            />
                          )}
                          {!this.props.website && (
                            <Input type="text" name="website" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-10">
                    <div className="grid grid-cols-1 gap-10">
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>
                          What business needs would you like to cover with our help?
                        </p>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(1);
                              this.handleChange('plan', 'Generating More Leads');
                            }}
                            className={`${activePlan.includes(1) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Generating More Leads</span>
                            {activePlan.includes(1) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(2);
                              this.handleChange('plan', 'Optimizing Conversion Rate');
                            }}
                            className={`${activePlan.includes(2) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Optimizing Conversion Rate</span>
                            {activePlan.includes(2) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(3);
                              this.handleChange('plan', 'Increasing website traffic');
                            }}
                            className={`${activePlan.includes(3) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increasing website traffic</span>
                            {activePlan.includes(3) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(4);
                              this.handleChange('plan', 'Increasing brand awareness and visibility');
                            }}
                            className={`${activePlan.includes(4) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increasing brand awareness and visibility</span>
                            {activePlan.includes(4) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(5);
                              this.handleChange('plan', 'Reducing the cost of customer acquisition');
                            }}
                            className={`${activePlan.includes(5) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Reducing the cost of customer acquisition</span>
                            {activePlan.includes(5) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(6);
                              this.handleChange('plan', 'Launching into new markets');
                            }}
                            className={`${activePlan.includes(6) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Launching into new markets</span>
                            {activePlan.includes(6) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-10">
                    <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Which best describes you business model?</p>

                    <div className="flex  grid-cols-1 gap-10">
                      <div className="form-group   w-half">
                        <div className="radio-item">
                          <input
                            type="radio"
                            id={'b2b_' + (this.props.id ? this.props.id : '')}
                            name="businessDescription"
                            value="B2B(Busines to Business)"
                            onChange={() => this.handleChange('businessDescription', 'B2B(Busines to Business)')}
                          />
                          <label htmlFor={'b2b_' + (this.props.id ? this.props.id : '')}> B2B(Busines to Business)</label>
                        </div>
                      </div>
                      <div className="form-group mr-5  ml-10 w-half">
                        <div className="radio-item  ">
                          <input
                            type="radio"
                            id={'b2c_' + (this.props.id ? this.props.id : '')}
                            name="businessDescription"
                            value="B2C (Busines to Consumer)"
                            onChange={() => this.handleChange('businessDescription', 'B2C (Busines to Consumer)\n')}
                          />
                          <label htmlFor={'b2c_' + (this.props.id ? this.props.id : '')}> B2C (Busines to Consumer)</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-10">
                    <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>
                      Is there anything specific we should know about your project?
                    </p>
                    <div className="mb-10">
                      <Textarea
                        type="text"
                        name="description"
                        bg="bg-gray-light resize-none"
                        required={false}
                        rows={4}
                        onChange={this.handleChange}
                        placeholder="Background, requirements, budget, deadline, etc."
                      />
                    </div>
                  </div>
                  <div className="mb-10">
                    <div className="grid grid-cols-3 gap-10">
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Your Name *</p>
                        <div className="mb-10">
                          <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                        </div>
                      </div>
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Your Email *</p>
                        <div className="mb-10">
                          <Input type="email" name="email" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                        </div>
                      </div>
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>Your Phone Number</p>
                        <div className="mb-10">
                          <Input type="number" name="phone-number" bg="bg-gray-light" required={false} onChange={this.handleChange} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row my-10">
                    <div className="form-group mr-30">
                      <label className="relative pl-30 cursor-pointer text-black text-14 md:text-18 flex items-center">
                        <input
                          id="nda"
                          className="absolute cursor-pointer opacity-0"
                          onChange={e => this.handleChange('nda', e.target.checked ? 'yes' : 'No')}
                          type="checkbox"
                          name="nda"
                        />
                        <span className="checkmark absolute left-0 w-20 h-20 border border-black rounded-sm" />
                        Send NDA
                      </label>
                    </div>
                  </div>
                  <div className="flex flex-row my-10">
                    <ReCAPTCHA sitekey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY} size={'normal'} ref={this.reRef} />
                  </div>
                  <input type="hidden" name="country" value={this.props.country} />
                  <div className="col-span-2">
                    <button
                      id="offer-submit"
                      type="submit"
                      className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default OrderNow;
